module.exports = __webpack_public_path__ + "media/images/common/menu_outer-0f47ef2c0321ae454195896f36b8537f.gif";